import React from 'react';
import { View, Text, ScrollView, StyleSheet } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import colors from '@/constants/Colors';
import { DrawerToggleButton } from "@react-navigation/drawer";
import Drawer from "expo-router/drawer";
import { GestureHandlerRootView } from 'react-native-gesture-handler';

export default function WhatsNew() {
    const insets = useSafeAreaInsets();

    // Get today's date in a readable format
    const today = new Date();
    const formattedDate = today.toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
    });

    return (
        <GestureHandlerRootView style={{ flex: 1 }}>
            <Drawer.Screen
                options={{
                    drawerLabel: "What's New",
                    title: "What's New",
                    headerStyle: {
                        backgroundColor: colors.primary,
                    },
                    headerTintColor: colors.accent,
                    headerLeft: () => <DrawerToggleButton tintColor={colors.accent} />
                }}
            />

            <View style={{ flex: 1, backgroundColor: colors.background }}>
                <ScrollView
                    style={styles.container}
                    contentContainerStyle={{ paddingBottom: insets.bottom + 20 }}
                >
                    <View style={styles.updateContainer}>
                        <Text style={styles.dateText}>9th May 2026</Text>
                        <Text style={styles.versionText}>Quick sign-in with Face ID, Touch ID or fingerprint</Text>
                        <View style={styles.bulletList}>
                            <View style={styles.bulletItem}>
                                <Text style={styles.bullet}>•</Text>
                                <Text style={styles.bulletText}>Skip typing your password every time — use Face ID, Touch ID or your fingerprint to sign in instead</Text>
                            </View>
                            <View style={styles.bulletItem}>
                                <Text style={styles.bullet}>•</Text>
                                <Text style={styles.bulletText}>Set it up the next time you sign in, or anytime from Settings → Access</Text>
                            </View>
                            <View style={styles.bulletItem}>
                                <Text style={styles.bullet}>•</Text>
                                <Text style={styles.bulletText}>Your credentials are stored securely on this device only — they're never synced or backed up</Text>
                            </View>
                            <View style={styles.bulletItem}>
                                <Text style={styles.bullet}>•</Text>
                                <Text style={styles.bulletText}>Not for you? Just tap "Not now" — you can always enable it later, and turn it off anytime</Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.updateContainer}>
                        <Text style={styles.dateText}>8th May 2026</Text>
                        <Text style={styles.versionText}>Easier notification permissions</Text>
                        <View style={styles.bulletList}>
                            <View style={styles.bulletItem}>
                                <Text style={styles.bullet}>•</Text>
                                <Text style={styles.bulletText}>Tap the red banner at the top of the app to open a new help screen that walks you through enabling push notifications</Text>
                            </View>
                            <View style={styles.bulletItem}>
                                <Text style={styles.bullet}>•</Text>
                                <Text style={styles.bulletText}>The screen shows your live permission status and includes an "Open Settings" button so you can fix it in one tap</Text>
                            </View>
                            <View style={styles.bulletItem}>
                                <Text style={styles.bullet}>•</Text>
                                <Text style={styles.bulletText}>Various stability fixes around notifications and the side menu</Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.updateContainer}>
                        <Text style={styles.dateText}>12th March 2026</Text>
                        <Text style={styles.versionText}>Social media consent</Text>
                        <View style={styles.bulletList}>
                            <View style={styles.bulletItem}>
                                <Text style={styles.bullet}>•</Text>
                                <Text style={styles.bulletText}>New "Social Media Consent" toggle in Settings → Details lets you choose whether you're happy to be featured in our social media content</Text>
                            </View>
                            <View style={styles.bulletItem}>
                                <Text style={styles.bullet}>•</Text>
                                <Text style={styles.bulletText}>You can change your mind at any time and we'll always respect your latest setting</Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.updateContainer}>
                        <Text style={styles.dateText}>6th January 2026</Text>
                        <Text style={styles.versionText}>Attendance and readiness in crew feedback</Text>
                        <View style={styles.bulletList}>
                            <View style={styles.bulletItem}>
                                <Text style={styles.bullet}>•</Text>
                                <Text style={styles.bulletText}>Crew Chiefs can now record attendance and readiness for each crew member when leaving feedback at the end of a job</Text>
                            </View>
                            <View style={styles.bulletItem}>
                                <Text style={styles.bullet}>•</Text>
                                <Text style={styles.bulletText}>Helps the office team spot reliable crew faster and feed it into future bookings</Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.updateContainer}>
                        <Text style={styles.dateText}>24th November 2025</Text>
                        <Text style={styles.versionText}>Finish Early improvements</Text>
                        <View style={styles.bulletList}>
                            <View style={styles.bulletItem}>
                                <Text style={styles.bullet}>•</Text>
                                <Text style={styles.bulletText}>Polished the Finish Early flow with clearer prompts and tighter timing checks so it only appears when it makes sense</Text>
                            </View>
                            <View style={styles.bulletItem}>
                                <Text style={styles.bullet}>•</Text>
                                <Text style={styles.bulletText}>Better visibility for the office team so any "available for more work" requests get picked up quickly</Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.updateContainer}>
                        <Text style={styles.dateText}>18th November 2025</Text>
                        <Text style={styles.versionText}>Feedback indicators on the home screen</Text>
                        <View style={styles.bulletList}>
                            <View style={styles.bulletItem}>
                                <Text style={styles.bullet}>•</Text>
                                <Text style={styles.bulletText}>Jobs that need feedback now show a clear indicator on the home screen and calendar so you can see what's outstanding at a glance</Text>
                            </View>
                            <View style={styles.bulletItem}>
                                <Text style={styles.bullet}>•</Text>
                                <Text style={styles.bulletText}>Tap the indicator to jump straight into the feedback form for that job</Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.updateContainer}>
                        <Text style={styles.dateText}>13th November 2025</Text>
                        <Text style={styles.versionText}>Crew photos in feedback</Text>
                        <View style={styles.bulletList}>
                            <View style={styles.bulletItem}>
                                <Text style={styles.bullet}>•</Text>
                                <Text style={styles.bulletText}>Crew Chiefs giving feedback now see each crew member's profile photo alongside their name, making it much easier to give feedback to the right person on a busy job</Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.updateContainer}>
                        <Text style={styles.dateText}>6th November 2025</Text>
                        <Text style={styles.versionText}>Finished Early Feature</Text>
                        <View style={styles.bulletList}>
                            <View style={styles.bulletItem}>
                                <Text style={styles.bullet}>•</Text>
                                <Text style={styles.bulletText}>You can now report when you've finished a job early from the job details page</Text>
                            </View>
                            <View style={styles.bulletItem}>
                                <Text style={styles.bullet}>•</Text>
                                <Text style={styles.bulletText}>This helps us maintain accurate health and safety records based on your actual working hours</Text>
                            </View>
                            <View style={styles.bulletItem}>
                                <Text style={styles.bullet}>•</Text>
                                <Text style={styles.bulletText}>If you're available, you can indicate you'd like more work - our operations team will see this and may offer you additional shifts</Text>
                            </View>
                            <View style={styles.bulletItem}>
                                <Text style={styles.bullet}>•</Text>
                                <Text style={styles.bulletText}>Don't worry - this won't affect your pay, which is based on your scheduled hours</Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.updateContainer}>
                        <Text style={styles.dateText}>20th October 2025</Text>
                        <Text style={styles.versionText}>Crew Chief Group Messages</Text>
                        <View style={styles.bulletList}>
                            <View style={styles.bulletItem}>
                                <Text style={styles.bullet}>•</Text>
                                <Text style={styles.bulletText}>Crew Chiefs can now create group chats with all crew members on a job to share important information and coordinate more effectively</Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.updateContainer}>
                        <Text style={styles.dateText}>20th August 2025</Text>
                        <Text style={styles.versionText}>Client and Venue Feedback</Text>
                        <View style={styles.bulletList}>
                            <View style={styles.bulletItem}>
                                <Text style={styles.bullet}>•</Text>
                                <Text style={styles.bulletText}>Crew Chiefs can now provide feedback for clients and venues on the job details page</Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.updateContainer}>
                        <Text style={styles.dateText}>12th August 2025</Text>
                        <Text style={styles.versionText}>Viewing Duty Manager</Text>
                        <View style={styles.bulletList}>
                            <View style={styles.bulletItem}>
                                <Text style={styles.bullet}>•</Text>
                                <Text style={styles.bulletText}>Duty Manager is now displayed in the menu bar</Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.updateContainer}>
                        <Text style={styles.dateText}>8th July 2025</Text>
                        <Text style={styles.versionText}>New features and improvements</Text>
                        <View style={styles.bulletList}>
                            <View style={styles.bulletItem}>
                                <Text style={styles.bullet}>•</Text>
                                <Text style={styles.bulletText}>Copy message button in messages</Text>
                            </View>
                            <View style={styles.bulletItem}>
                                <Text style={styles.bullet}>•</Text>
                                <Text style={styles.bulletText}>Copy job information in job details</Text>
                            </View>
                        </View>
                    </View>

                    <View style={styles.updateContainer}>
                        <Text style={styles.dateText}>4th June 2025</Text>
                        <Text style={styles.versionText}>Calendar improvements for smaller screens</Text>
                        <View style={styles.bulletList}>
                            <View style={styles.bulletItem}>
                                <Text style={styles.bullet}>•</Text>
                                <Text style={styles.bulletText}>The calendar can now be hidden by tapping the calendar icon in the top right corner</Text>

                            </View>
                            <View style={styles.bulletItem}>
                                <Text style={styles.bullet}>•</Text>
                                <Text style={styles.bulletText}>When the calendar is hidden, the footer shows the total hours and pay for the selected day rather than the whole month</Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.updateContainer}>
                        <Text style={styles.dateText}>22nd May 2025</Text>
                        <Text style={styles.versionText}>Calendar improvements</Text>
                        <View style={styles.bulletList}>
                            <View style={styles.bulletItem}>
                                <Text style={styles.bullet}>•</Text>
                                <Text style={styles.bulletText}>Updates to the calendar to make it clearer and easier to use</Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.updateContainer}>
                        <Text style={styles.dateText}>15th May 2025</Text>
                        <Text style={styles.versionText}>More personal profile information</Text>

                        <View style={styles.bulletList}>
                            <View style={styles.bulletItem}>
                                <Text style={styles.bullet}>•</Text>
                                <Text style={styles.bulletText}>Optionally specify your gender and/or preferred pronouns</Text>
                            </View>

                            <View style={styles.bulletItem}>
                                <Text style={styles.bullet}>•</Text>
                                <Text style={styles.bulletText}>Optionally specify your dietary requirements (This will be shared with the venue you are working at only if you specify them)</Text>
                            </View>

                            <View style={styles.bulletItem}>
                                <Text style={styles.bullet}>•</Text>
                                <Text style={styles.bulletText}>Specify your target monthly pay (This will help us match you with the right jobs)</Text>
                            </View>
                            <View style={styles.bulletItem}>
                                <Text style={styles.bullet}>•</Text>
                                <Text style={styles.bulletText}>Specify your preferred payroll frequency (For Sub-contractors and limited company workers)</Text>
                            </View>

                        </View>
                    </View>

                    <View style={styles.updateContainer}>
                        <Text style={styles.dateText}>14th May 2025</Text>

                        <View style={styles.bulletList}>
                            <View style={styles.bulletItem}>
                                <Text style={styles.bullet}>•</Text>
                                <Text style={styles.bulletText}>Added new "What's New" section to keep you updated on app changes</Text>
                            </View>
                        </View>
                    </View>
                </ScrollView>
            </View>
        </GestureHandlerRootView>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        padding: 16,
    },
    updateContainer: {
        marginBottom: 10,
        backgroundColor: '#1E1E1E', // Dark card background
        borderRadius: 8,
        padding: 16,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.1,
        shadowRadius: 4,
        elevation: 3,
    },
    dateText: {
        fontSize: 18,
        fontWeight: 'bold',
        color: colors.text.primary,
        marginBottom: 4,
    },
    versionText: {
        fontSize: 16,
        color: colors.text.secondary,
        marginBottom: 16,
    },
    bulletList: {
        marginTop: 8,
    },
    bulletItem: {
        flexDirection: 'row',
        marginBottom: 12,
        alignItems: 'flex-start',
    },
    bullet: {
        fontSize: 16,
        marginRight: 8,
        color: colors.accent,
        lineHeight: 22,
    },
    bulletText: {
        fontSize: 16,
        color: colors.text.primary,
        flex: 1,
        lineHeight: 22,
    },
}); 